import type { MenuItemDTO } from '@/services/data-contracts';
import { message } from 'antd';
import { validRoutePaths } from '@/utils/routeUtils';

/**
 * @see https://umijs.org/docs/max/access#access
 * 菜单鉴权控制 - 从接口获取用户权限
 */

// 用于标记是否已经显示过权限为空的提示
let hasShownEmptyPermissionWarning = false;

// 将菜单树转换为扁平的 path 数组，且只包含前端真实存在的路由
function flattenMenuPaths(menus: MenuItemDTO[]): string[] {
  const paths: string[] = [];

  function traverse(menuList: MenuItemDTO[]) {
    menuList.forEach(menu => {
      // 只添加在前端路由配置中真实存在的路径
      if (menu.path && validRoutePaths.has(menu.path)) {
        paths.push(menu.path);
      }
      if (menu.children && menu.children.length > 0) {
        traverse(menu.children);
      }
    });
  }

  traverse(menus);
  return paths;
}

export default function access(
  initialState: { currentUser?: any; userMenus?: MenuItemDTO[] } | undefined,
) {
  // 不存在用户信息，不允许进入
  if (!initialState?.currentUser) {
    return {
      auth: false
    };
  }

  // 从 initialState 中获取用户菜单权限
  const userMenus = initialState?.userMenus || [];
  const allowedPaths = flattenMenuPaths(userMenus);

  // 检测权限数组是否为空
  const hasNoPermissions = allowedPaths.length === 0;

  return {
    auth: (route: any) => {
      // 如果没有 path，默认允许（如首页、登录页等）
      if (!route.path) {
        return true;
      }

      // 如果权限数组为空，阻止访问并弹出提示
      if (hasNoPermissions) {
        if (!hasShownEmptyPermissionWarning) {
          hasShownEmptyPermissionWarning = true;
          message.warning('您暂无任何菜单权限，请联系管理员分配权限');
        }
        return false;
      }

      // 检查路由路径是否在用户权限的菜单列表中
      return allowedPaths.includes(route.path);
    },
  };
}

